// CSS Modules - component class name prefix: Modal__

<template>
  <div :class="[$style.container, 'modal', { 'is-active': modalActive }]">
    <div class="modal-background" @click="internallyCloseModal"></div>
    <div :class="['modal-content', { [$style.product]: isProduct }]">
      <div
        ref="modalContent"
        :class="[$style.content, { [$style.video]: isVideo }]"
      >
        <slot></slot>
      </div>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="internallyCloseModal"
    ></button>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    isProduct: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalActive: false,
      htmlElement: null
    };
  },
  methods: {
    openModal() {
      const iframe = this.$refs.modalContent.querySelector("iframe");

      if (iframe && this.isVideo && !iframe.src) {
        iframe.src = iframe.getAttribute("data-src");
      }

      this.modalActive = true;
      this.htmlElement.classList.add("is-clipped");
    },
    closeModal() {
      this.modalActive = false;
      this.htmlElement.classList.remove("is-clipped");
      if (this.isVideo) {
        this.$refs.modalContent
          .querySelector("iframe")
          .contentWindow.postMessage(
            '{"event":"command","func":"stopVideo","args":""}',
            "*"
          );
      }
    },
    internallyCloseModal() {
      this.closeModal();
      this.$emit("closeModal");
    },
    escCloseModal(event) {
      if (event.keyCode === 27) {
        this.internallyCloseModal();
      }
    }
  },
  watch: {
    isModalOpen: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        newValue === true ? this.openModal() : this.closeModal();
      }
    }
  },
  mounted() {
    window.addEventListener("keyup", this.escCloseModal);
    this.htmlElement = document.querySelector("html");
  },
  destroyed() {
    window.removeEventListener("keyup", this.escCloseModal);
  }
};
</script>

<style module lang="scss">
@import "./Modal.scss";
</style>
